/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_Landing_BtnInputs */

const en_service_peer_support_landing_btn = /** @type {(inputs: Service_Peer_Support_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn About Peer Support`)
};

const fr_service_peer_support_landing_btn = /** @type {(inputs: Service_Peer_Support_Landing_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus sur le soutien par les pairs`)
};

/**
* | output |
* | --- |
* | "Learn About Peer Support" |
*
* @param {Service_Peer_Support_Landing_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_landing_btn = /** @type {((inputs?: Service_Peer_Support_Landing_BtnInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_Landing_BtnInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_landing_btn(inputs)
	return fr_service_peer_support_landing_btn(inputs)
});